import template from './trip-approver-override.html';
import tripEvents from './../../trip/config/events.constant.js';


const DIRECTIVE_NAME = ApproverOverride.DIRECTIVE_NAME = 'ktApproverOverride';
export default function ApproverOverride() {
    return {
        restrict: 'A',
        controller: ApproverOverrideController,
        controllerAs: '$ctrl',
        template,
        bindToController: true,
        scope: {
            model: `=${DIRECTIVE_NAME}`,
            input: `=${DIRECTIVE_NAME}Input`,
            requiredValidationMessage: `@${DIRECTIVE_NAME}RequiredValidationMessage`,
            disableSearch: `=${DIRECTIVE_NAME}Disable`,
        },
        link,
    };

    function link($scope, $elem, $attrs, ApproverOverrideCtrl) {
        ApproverOverrideCtrl.$onInit();
    }
}

export function ApproverOverrideController(
    $scope,
    $rootScope,
) {
    'ngInject';
    const vm = this;

    Object.assign(vm, {
        $onInit,
        subscribe,
    });

    function $onInit() {
        subscribe();
        vm.people = null;
    }

    function subscribe() {
       $rootScope.$on(tripEvents.CLEAR_APPROVER, (event, obj) => {
            const app = [];
            if (obj.item.value !== null) {
                const values = $rootScope.approvers[obj.item.value];
                for (let i = 0; i < values.length; i++) {
                    const approver = {
                        ContactId: values[i].ContactId,
                        Email: values[i].Email,
                        FirstName: values[i].FirstName,
                        FullName: values[i].FullName,
                        LastName: values[i].LastName,
                    };
                    app.push(approver);
                }
                vm.people = app;
            }
        });
    }

    $scope.setApprover = ($item, $model) => {
            vm.over = $model;
            vm.input.ApproverId = $model.ContactId;
    };

}



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-approver-override/trip-approver-override-component.js